import React, { useEffect, useRef, useMemo, useState } from 'react'
import { embedDashboard } from '@superset-ui/embedded-sdk'
import STRINGS from 'utils/strings'
import { INSIGHTS_VENDORS } from '../../../utils/utils'

import '../stylesheets/EmbeddedInsights.scss'

const EmbeddedInsights = ({ embeddedUrl, vendorType, supersetData }) => {
  const supersetContainer = useRef(null)
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const isVendorTypeHolistics = useMemo(() => vendorType === INSIGHTS_VENDORS.holistics, [vendorType])

  useEffect(() => {
    if (isVendorTypeHolistics || !supersetData || !supersetContainer.current) {
      return
    }

    const { embed_code: embedCode, jwt, base_url: baseUrl } = supersetData || {}

    setIsLoading(true)
    setError(null)

    embedDashboard({
      id: embedCode,
      supersetDomain: baseUrl,
      mountPoint: supersetContainer.current,
      fetchGuestToken: () => jwt,
      dashboardUiConfig: {
        hideTitle: true,
        filters: {
          expanded: true,
        },
      },
    })
      .then(() => {
        // Dashboard embedded successfully
        setIsLoading(false)

        // Style the iframe after it loads
        const iframe = supersetContainer.current?.querySelector('iframe')
        if (iframe) {
          iframe.style.width = '100%'
          iframe.style.height = '800px'
          iframe.onload = () => console.log('Iframe loaded')
        }
      })
      .catch(err => {
        console.error('Failed to embed dashboard:', err)
        setError(err.message || 'Failed to embed dashboard')
        setIsLoading(false)
      })

    return () => {
      if (supersetContainer.current) {
        supersetContainer.current.innerHTML = ''
      }
    }
  }, [isVendorTypeHolistics, supersetData])

  if (error) {
    return (
      <div className='embedded-insights page'>
        <div className='selected-button-list'>
          <h4>{STRINGS.datacubedInsights}</h4>
        </div>
        <div className='error-container' style={{ padding: '20px', color: 'red' }}>
          <h3>Error Loading Dashboard</h3>
          <p>{error}</p>
          <p>Check console for details</p>
        </div>
      </div>
    )
  }

  return (
    <div className='embedded-insights page'>
      <div className='selected-button-list'>
        <h4>{STRINGS.datacubedInsights}</h4>
      </div>
      {isVendorTypeHolistics ? (
        <iframe className='embedded-iframe' src={embeddedUrl} id='embedded-iframe' allowFullScreen />
      ) : (
        <>
          {isLoading && <div className='loading'>Loading dashboard...</div>}
          <div
            className='embedded-iframe superset-container'
            id='embedded-iframe'
            ref={supersetContainer}
            style={{ minHeight: '800px' }}
          />
        </>
      )}
    </div>
  )
}

export default EmbeddedInsights
